
const jsonDateRegexp: RegExp = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d$/; // iso date 2023-03-19T19:00:00

class ParserWithBenefits {

    public static parseWithWarnings(sJson: string, sUrl: string): any {
        if (sJson == null || sJson == "") {
            return null;
        }
        return JSON.parse(sJson, (key, value) => {
            return this.reviverWithWarnings(key, value, sUrl);
        });
    }

    public static parse(sJson: string): any {
        if (sJson == null || sJson == "") {
            return null;
        }
        return JSON.parse(sJson, this.reviver)
    }

    protected static reviver(key: string, value: string) {

        if (typeof value !== 'string') {
            return value;
        }

        const dateMatch = jsonDateRegexp.exec(value);

        if (!dateMatch) {
            return value;
        }

        return new Date(value);
    }

    protected static reviverWithWarnings(key: string, value: string, url: string) {

        if (typeof value !== 'string') {
            return value;
        }

        const dateMatch = jsonDateRegexp.exec(value);

        if (!dateMatch) {
            return value;
        }

        let partialUrl = url.replace(window.appRoot, "");
        console.warn(`Endpoint '${partialUrl}' responded an object with a key named '${key}'. this key contains possible Date object with string '${value}'. use handleAs = 'jsonWithDate' in RequestManager`);
        console.warn("---------------------- To ignore this warning please set handleAs = 'json' ---------------------- ");
        return value;
    }

    protected static stringify(json: any) {
        return JSON.stringify(json, (key, value) => { return this.stringifyReplacer(key, value); });
    }

    private static stringifyReplacer(key, value) {
        if (typeof (value?.getTimezoneOffset) == "function") {
            debugger;
            let date = value as Date;
            let offset = date.getTimezoneOffset();

            let newLocaleDate = new Date(date.getTime() + -1 * offset * 60);

            return newLocaleDate;
        } else {
            return value;
        }
    }

}

export default ParserWithBenefits;